var _style, _path, _g, _g2, _path2, _path3, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg05Ventilation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    width: 186.654,
    height: 154.851,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st812{fill:#3b5775}.st814{fill:#58c9cc}.st816,.st819{fill:none;stroke:#ccc;stroke-width:.6532;stroke-miterlimit:10}.st819{stroke:#d1d3d4;stroke-width:.7538}")), /*#__PURE__*/React.createElement("path", {
    d: "M159.293 20.699c-22.435-12.08-47.216 28.265-64.761 9.199C73.719 7.28 40.084-14.985 20.987 14.178 4.5 39.359 34.34 59.498 21.36 82.108c-6.76 11.774-37.142 27.529-10.781 53.25 13.222 12.9 15.87 19.473 32.972 19.494 33.344.04 35.904-27.27 58.844-43.081 21.127-14.561 60.077 6.41 76.46-19.3 15.909-24.961 6.54-57.716-19.562-71.771z",
    id: "path1203",
    style: {
      fill: "#ecf0f1"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1317",
    transform: "translate(-581.592 -1101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1237"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st812",
    d: "M716.267 1250.034h-45.292a20.705 20.705 0 0 1 9.018-17.112c3.381-2.323 5.51-6.062 5.51-10.164v-25.69c0-4.564 3.735-8.546 8.297-8.446 2.174.048 4.14.94 5.563 2.375a8.086 8.086 0 0 1 2.378 5.735v26.024c0 4.052 2.042 7.809 5.397 10.082 5.511 3.735 9.129 10.043 9.129 17.196z",
    id: "path1229"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M716.404 1252.777h-45.567a2.349 2.349 0 1 1 0-4.699h45.567a2.35 2.35 0 1 1 0 4.699z",
    id: "path1231",
    style: {
      fill: "#5f81a0"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st812",
    id: "rect1233",
    d: "M691.662 1170.241h3.919v21.689h-3.919z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1305"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g1247"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M701.817 1141.608c-1.318-6.666-4.991-12.516-11.881-15.341-4.187-1.717-8.926-1.551-13.361-.653-11.888 2.408-23.18 11.013-25.576 22.904-.438 2.173-.542 4.562.578 6.475 3.14 5.361 12.44 1.175 17.099.375 4.87-.836 10.536-.491 13.809 3.211 1.597 1.807 2.389 4.165 3.547 6.28 1.158 2.115 2.963 4.161 5.359 4.433 3.4.386 6.051-2.873 7.518-5.964 3.002-6.324 4.336-14.5 2.908-21.72z",
    id: "path1239"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M666.606 1175.73c-5.114 4.475-8.344 10.581-7.345 17.96.607 4.484 3.12 8.506 6.115 11.897 8.03 9.092 21.128 14.568 32.624 10.697 2.101-.708 4.222-1.811 5.319-3.738 3.073-5.399-5.202-11.36-8.225-14.996-3.159-3.8-5.693-8.879-4.124-13.564.766-2.286 2.412-4.151 3.665-6.212 1.252-2.061 2.122-4.646 1.16-6.857-1.366-3.137-5.513-3.804-8.924-3.529-6.978.563-14.726 3.496-20.265 8.342z",
    id: "path1241"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M713.763 1189.163c6.432 2.191 13.335 1.936 19.226-2.619 3.58-2.767 5.806-6.954 7.246-11.244 3.859-11.5 2.052-25.581-7.048-33.601-1.663-1.466-3.68-2.751-5.897-2.737-6.212.039-7.237 10.186-8.874 14.62-1.711 4.635-4.843 9.37-9.685 10.354-2.363.48-4.801-.014-7.212-.068-2.411-.054-5.085.485-6.518 2.424-2.034 2.752-.538 6.677 1.406 9.493 3.976 5.761 10.389 11.005 17.356 13.378z",
    id: "path1243"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-14.406 694.027 1169.216)",
    className: "st812",
    cx: 693.998,
    cy: 1169.19,
    id: "ellipse1245",
    r: 8.609
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1255",
    style: {
      opacity: 0.22
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M711.148 1144.967c.917-6.733-.657-13.459-6.257-18.368-3.403-2.983-7.939-4.365-12.425-4.955-12.026-1.582-25.5 2.891-31.627 13.36-1.12 1.913-1.994 4.139-1.556 6.312 1.229 6.09 11.384 5.15 16.051 5.906 4.878.791 10.125 2.956 12.018 7.52.924 2.227.907 4.715 1.316 7.091.409 2.376 1.451 4.898 3.629 5.933 3.091 1.469 6.656-.753 9.047-3.2 4.894-5.007 8.81-12.307 9.804-19.599z",
    id: "path1249"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M666.766 1165.808c-6.289 2.572-11.327 7.299-12.779 14.602-.882 4.438.189 9.058 1.921 13.238 4.643 11.206 15.253 20.638 27.383 20.709 2.217.013 4.582-.342 6.244-1.809 4.659-4.109-1.232-12.434-2.91-16.854-1.754-4.62-2.502-10.246.503-14.168 1.467-1.914 3.63-3.143 5.483-4.685 1.853-1.542 3.516-3.706 3.323-6.109-.273-3.411-3.98-5.388-7.295-6.235-6.781-1.733-15.061-1.474-21.873 1.311z",
    id: "path1251"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M707.006 1193.823c5.372 4.161 11.984 6.16 19.035 3.766 4.285-1.455 7.75-4.693 10.504-8.283 7.383-9.624 10.247-23.529 4.243-34.069-1.097-1.926-2.587-3.797-4.688-4.503-5.888-1.981-10.152 7.284-13.141 10.947-3.124 3.829-7.622 7.29-12.522 6.648-2.391-.313-4.536-1.572-6.799-2.406-2.263-.834-4.967-1.192-6.952.177-2.817 1.942-2.676 6.141-1.752 9.435 1.89 6.74 6.254 13.782 12.072 18.288z",
    id: "path1253"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g1265"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 694.177 1169.472)",
    className: "st816",
    cx: 694.187,
    cy: 1169.458,
    id: "ellipse1257",
    r: 45.347
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 694.177 1169.472)",
    className: "st816",
    cx: 694.187,
    cy: 1169.458,
    id: "ellipse1259",
    r: 35.843
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st816",
    cx: 694.187,
    cy: 1169.458,
    r: 26.405,
    id: "circle1261"
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-79.42 694.136 1169.441)",
    className: "st816",
    cx: 694.187,
    cy: 1169.458,
    id: "ellipse1263",
    r: 19.09
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1283",
    style: {
      opacity: 0.48
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M657.884 1112.425c2.255-1.67 4.676-3.108 7.156-4.444a66.489 66.489 0 0 1 7.759-3.368c5.319-1.922 10.926-3.042 16.574-3.464 5.651-.377 11.36-.054 16.897 1.102a66.634 66.634 0 0 1 8.155 2.247c2.643.976 5.242 2.061 7.708 3.399-2.626-.981-5.263-1.899-7.96-2.593a67.517 67.517 0 0 0-8.137-1.748c-5.477-.828-11.029-1.094-16.541-.689-5.515.37-10.974 1.412-16.282 2.999a67.965 67.965 0 0 0-7.812 2.872c-2.573 1.068-5.055 2.346-7.517 3.687z",
    id: "path1267"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M628 1155.586c.157-4.049 1.2-8.008 2.692-11.758 1.538-3.731 3.544-7.299 6.252-10.315-1.544 3.738-3.195 7.297-4.655 10.962-1.507 3.646-2.805 7.35-4.289 11.111z",
    id: "path1269"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M658.568 1226.905c-4.473-1.981-8.488-4.912-12.021-8.299-3.5-3.421-6.561-7.338-8.679-11.75 3.251 3.642 6.423 7.2 9.877 10.512 3.419 3.348 7.076 6.408 10.823 9.537z",
    id: "path1271"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M757.428 1145.51c1.157 2.518 2.067 5.148 2.86 7.815a66.696 66.696 0 0 1 1.708 8.178c.767 5.527.821 11.174.096 16.725a61.547 61.547 0 0 1-4.351 16.15c-1.084 2.574-2.367 5.054-3.745 7.469-1.457 2.372-3.017 4.674-4.761 6.826 2.9-4.716 5.398-9.633 7.272-14.78 1.845-5.149 3.219-10.466 3.875-15.884.75-5.409.742-10.899.302-16.352a68.11 68.11 0 0 0-1.214-8.132c-.508-2.706-1.249-5.362-2.042-8.015z",
    id: "path1273"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M675.48 1227.737c-1.17-.318-2.341-.652-3.508-1.007l-3.44-1.25-3.336-1.52-3.245-1.722c-4.263-2.426-8.17-5.478-11.659-8.938-3.461-3.488-6.511-7.396-8.935-11.662l-1.718-3.246-1.516-3.339-1.244-3.442a121.054 121.054 0 0 1-1-3.51c.493 1.114.97 2.227 1.426 3.345l1.586 3.256 1.708 3.178 1.888 3.066c2.633 4.008 5.627 7.767 9.022 11.135 3.366 3.397 7.125 6.393 11.13 9.031l3.066 1.891 3.177 1.713 3.254 1.59c1.118.458 2.23.937 3.344 1.431z",
    id: "path1275"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M741.383 1208.385c-2.066 3.571-4.917 6.629-8.092 9.246-3.205 2.58-6.779 4.754-10.699 6.042 3.274-2.495 6.514-4.825 9.612-7.378 3.128-2.513 6.072-5.211 9.179-7.91z",
    id: "path1277"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M743.972 1133.879c2.109 1.773 3.685 4.012 4.983 6.379 1.252 2.392 2.24 4.947 2.54 7.686-1.578-2.252-2.796-4.564-4.059-6.874-1.217-2.334-2.465-4.63-3.464-7.191z",
    id: "path1279"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st814",
    d: "M641.116 1139.003c2.486-5.683 6.324-10.768 10.876-15.029 4.58-4.229 9.934-7.688 15.79-9.736-5.248 3.278-10.178 6.842-14.617 10.998-4.471 4.122-8.391 8.777-12.049 13.767z",
    id: "path1281"
  }))), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45.001 694.177 1169.472)",
    cx: 694.187,
    cy: 1169.458,
    id: "ellipse1285",
    r: 54.796,
    style: {
      fill: "none",
      stroke: "#d1d3d4",
      strokeWidth: 1.5076,
      strokeMiterlimit: 10
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st819",
    id: "line1287",
    d: "m732.83 1130.606-38.643 38.852"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st819",
    id: "line1289",
    d: "m694.039 1114.66.148 54.798"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st819",
    id: "line1291",
    d: "m655.334 1130.815 38.853 38.643"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st819",
    id: "line1293",
    d: "m639.389 1169.606 54.798-.148"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st819",
    id: "line1295",
    d: "m655.543 1208.311 38.644-38.853"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st819",
    id: "line1297",
    d: "m694.334 1224.256-.147-54.798"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st819",
    id: "line1299",
    d: "m733.039 1208.102-38.852-38.644"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st819",
    id: "line1301",
    d: "m748.985 1169.311-54.798.147"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1315"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st814",
    cx: 685.05,
    cy: 1243.299,
    r: 1.934,
    id: "circle1307"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st814",
    cx: 690.764,
    cy: 1243.299,
    r: 1.934,
    id: "circle1309"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-76.714 696.565 1243.37)",
    className: "st814",
    cx: 696.478,
    cy: 1243.299,
    id: "ellipse1311",
    r: 1.934
  })), /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-76.714 702.28 1243.37)",
    cx: 702.192,
    cy: 1243.299,
    id: "ellipse1313",
    r: 1.934,
    style: {
      fill: "#d3cdd0"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg05Ventilation);
export default __webpack_public_path__ + "static/media/05-Ventilation.f9bed320ab0c4448e57d496db33b812b.svg";
export { ForwardRef as ReactComponent };